export default {
    salaoId: '65dd03bc0f0818dcf7450321',
    bucketUrl: 'https://appselmacosso.s3.sa-east-1.amazonaws.com',
    baseURL: 'http://api.institutoselmacosso.com.br'
}